import styled, { keyframes } from 'styled-components';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

//theme
import { homeColor, gradBrand } from '@/theme/ai';

//components
import { Section } from '@/containers-ai/SectionHeading';

const run = keyframes`
  from { left: 12.5%; }
  to { left: calc(87.5% - 10px); }
`;

export const LineupSection = styled(Section)`
  padding: 72px 0;
  background: ${homeColor.bg};

  @media (min-width: 861px) {
    padding: 96px 0;
  }
`;

export const Life = styled.div`
  margin-top: 64px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 44px 12px;
  position: relative;

  @media (min-width: 861px) {
    grid-template-columns: repeat(4, 1fr);
    gap: 0;

    /* The rail through the four stage circles, with a dot running along it. */
    &::before {
      content: '';
      position: absolute;
      top: 44px;
      left: 12.5%;
      right: 12.5%;
      height: 2px;
      background: ${gradBrand};
      opacity: 0.5;
    }

    &::after {
      content: '';
      position: absolute;
      top: 40px;
      left: 12.5%;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      background: ${homeColor.lime};
      box-shadow: 0 0 12px ${homeColor.lime};
      animation: ${run} 6s linear infinite;
    }

    @media (prefers-reduced-motion: reduce) {
      &::after {
        animation: none;
      }
    }
  }
`;

export const Stage = styled.div`
  position: relative;
  text-align: center;
`;

export const StageCount = styled.a`
  position: relative;
  z-index: 1;
  display: grid;
  place-content: center;
  width: 88px;
  height: 88px;
  margin: 0 auto 22px;
  border-radius: 50%;
  border: 1.5px solid ${homeColor.cyan};
  background: radial-gradient(
    circle at 30% 30%,
    ${homeColor.surface},
    ${homeColor.surface2}
  );
  color: ${homeColor.white};
  box-shadow: 0 0 30px rgba(0, 215, 215, 0.2);
  transition:
    transform 0.2s,
    box-shadow 0.2s;

  &:hover {
    transform: scale(1.06);
    box-shadow: 0 0 40px rgba(0, 215, 215, 0.47);
  }

  &:focus-visible {
    outline: 2px solid ${homeColor.cyan};
    outline-offset: 3px;
    border-radius: 50%;
  }

  small {
    margin-top: 4px;
    font-family: ${getToken('font-family-default')};
    font-size: 12px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: ${homeColor.muted};
  }
`;

export const StageCountValue = styled.b`
  display: block;
  width: fit-content;
  margin-inline: auto;
  font-family: ${getToken('font-family-title')};
  font-size: 24px;
  font-weight: 800;
  line-height: 1;
  background: linear-gradient(45.01deg, #00d7d7 23.29%, #84f11e 88.12%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

export const StageName = styled.h3`
  margin: 0 0 12px;
  font-family: ${getToken('font-family-default')};
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: ${homeColor.cyan};
`;

export const AgentLink = styled.a`
  display: block;
  width: auto;
  max-width: 100%;
  margin: 0 auto 6px;
  padding: 5px 10px;
  border-radius: 14px;
  font-family: ${getToken('font-family-default')};
  font-size: 15px;
  color: ${homeColor.chipInk};
  transition: all 0.2s;

  @media (min-width: 861px) {
    width: max-content;
    border-radius: 999px;
  }

  &:hover {
    background: ${gradBrand};
    color: ${homeColor.ink};
    font-weight: 700;
  }

  &:focus-visible {
    outline: 2px solid ${homeColor.cyan};
    outline-offset: 3px;
    border-radius: 8px;
  }

  ${(props) =>
    props.$custom &&
    `
    color: ${homeColor.lime};
    border: 1px dashed rgba(132, 241, 30, 0.4);
  `}
`;

export const Bridge = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-top: 64px;
  font-family: ${getToken('font-family-default')};
  font-size: 15px;
  color: ${homeColor.muted};

  span {
    width: 1px;
    height: 40px;
    background: linear-gradient(${homeColor.lineCool}, ${homeColor.cyan});
  }
`;
